import React from 'react';
import { Facebook, Instagram, MessageCircle } from 'lucide-react';
import { trackEvent } from '../../lib/analytics';

const SOCIAL_LINKS = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/profile.php?id=61570804654680',
    Icon: Facebook,
    hoverClass: 'hover:bg-cyan-600',
    event: ['social_click', { event_category: 'Social Media', event_label: 'Facebook' }],
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/assetwise_business_consultants/',
    Icon: Instagram,
    hoverClass: 'hover:bg-cyan-600',
    event: ['social_click', { event_category: 'Social Media', event_label: 'Instagram' }],
  },
  {
    label: 'WhatsApp',
    href: 'https://wa.me/919619527810',
    Icon: MessageCircle,
    hoverClass: 'hover:bg-green-600',
    event: ['whatsapp_click', { event_category: 'Engagement', event_label: 'Footer WhatsApp' }],
  },
];

export const FooterSocial = () => (
  <div className="flex gap-4 mt-6">
    {SOCIAL_LINKS.map(({ label, href, Icon, hoverClass, event }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label}
        data-testid={`footer-social-${label.toLowerCase()}`}
        onClick={() => trackEvent(...event)}
        className={`w-10 h-10 bg-gray-800 ${hoverClass} rounded-full flex items-center justify-center transition-colors`}
      >
        <Icon className="w-5 h-5" />
      </a>
    ))}
  </div>
);

export default FooterSocial;
